import styled from "styled-components";

export const Container = styled.footer`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 30px;
  button {
    border: 0;
    border-radius: 50px;
    padding: 27px 20px;
    position: fixed;
    bottom: 25px;
    right: 25px; 
    font-weight: bold;
  }
`;


